// antd v4's <DatePicker> is hardwired to moment by default. To drop moment
// entirely (Issue 22) we regenerate the picker against dayjs using antd's
// official generatePicker factory + rc-picker's dayjs config. Styles come from
// the global `antd/dist/antd.css` already imported in index.js, so no extra
// style import is needed. Emits/consumes dayjs objects instead of moment.
import generatePicker from 'antd/es/date-picker/generatePicker';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';

const DatePicker = generatePicker(dayjsGenerateConfig);

export default DatePicker;
